import React from "react";
import "./SkillsDisplay.css";

const SkillsDisplay = ({ skills = [], onShowTooltip, onHideTooltip }) => {
  const maxSkillsToShow = 3;
  const skillsToDisplay = skills.slice(0, maxSkillsToShow);
  const remainingSkills = skills.slice(maxSkillsToShow);

  if (!skills || skills.length === 0) {
    return <div>No skills available</div>;
  }

  return (
    <div className="skills-display-container">
      {skillsToDisplay.map((skill, index) => (
        <div
          key={index}
          className="skill-item"
          style={{
            maxWidth: `${
              skills?.length === 1
                ? "100%"
                : skills?.length === 2
                ? "49%"
                : skills?.length === 3
                ? "33%"
                : "25%"
            }`,
          }}
        >
          <div className="marketPlaceCardChip">{skill}</div>
        </div>
      ))}

      {remainingSkills.length > 0 && (
        <div
          className="more-skills-container"
          onMouseEnter={onShowTooltip}
          onMouseLeave={onHideTooltip}
        >
          <div className="marketplace-skills-more-count">
            +{remainingSkills.length} more
          </div>
        </div>
      )}
    </div>
  );
};

export default SkillsDisplay;
